export default __webpack_public_path__ + "static/media/KathyLovelace.4bf03282.png";